import { render, staticRenderFns } from "./CCRESVisu.vue?vue&type=template&id=036af122"
import script from "./CCRESVisu.vue?vue&type=script&lang=js"
export * from "./CCRESVisu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports